var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLgvLabelTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4102_2721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8332 10.4248C17.3301 10.4248 12.8457 14.9092 12.8457 20.4123C12.8457 25.9154 17.3301 30.3997 22.8332 30.3997C28.3363 30.3997 32.8206 25.9154 32.8206 20.4123C32.8206 14.9092 28.3363 10.4248 22.8332 10.4248ZM27.6072 18.1151L21.9443 23.778C21.8045 23.9179 21.6147 23.9978 21.4149 23.9978C21.2152 23.9978 21.0254 23.9179 20.8856 23.778L18.0592 20.9516C17.7695 20.662 17.7695 20.1826 18.0592 19.8929C18.3488 19.6033 18.8282 19.6033 19.1178 19.8929L21.4149 22.19L26.5485 17.0565C26.8381 16.7668 27.3175 16.7668 27.6072 17.0565C27.8968 17.3461 27.8968 17.8155 27.6072 18.1151Z",
    fill: "#238749"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4102_2721",
    x: -4.56059,
    y: -1.84606,
    width: 54.7882,
    height: 54.7882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.13641
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.70461
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.529412 0 0 0 0 0.286275 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4102_2721"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4102_2721",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgvLabelTick);
export default __webpack_public_path__ + "static/media/lgvLabelTick.d1125d37a7b22e872d3dc16d3f71be62.svg";
export { ForwardRef as ReactComponent };